<template>
  <el-row :gutter="8" class="hidden-md-and-down">
    <el-col :span="22">
    <el-button v-show="isManager('finance|property|admin')" icon="fa fa-trash-alt"
    @click="deleteEntry()" size="small" type="danger" circle :disabled="isViewOnly()"></el-button>
    </el-col>
  </el-row>
  </template>

  <script>

  import PostMixins from '@/mixins/PostMixins'
  import ContactsPopover from '@/components/atoms/ContactsPopover'

  export default {
    mixins: [PostMixins],
    components: {
      ContactsPopover
    },

    props: {
      rowData: {
        type: Object,
        required: true
      },
      tableRef: {
        type: String,
        default: 'insurance-table'
      }
    },
    methods: {
      deleteEntry () {
        let msg = this.rowData.policyType + ' for Policy ' + this.rowData.policyNo

        this.deleteItem(this, this.rowData.id, '/insurance', msg, this.onDelete)
      },
      onDelete (response) {
        this.$events.emit(this.tableRef + '-refresh-table')
        this.$emit('update-stats')
      }
    }
  }
  </script>

  <style>
  .item {
    margin-top: 10px;
    margin-right: 40px;
  }
  </style>
